<template>
  <div class="share-content" @click.stop="bindStop">
    <div class="title">分享到</div>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="list-scroll">
      <div class="list" v-show="shareType == 0">
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="bindClick(index)"
        >
          <div
            class="item-icon"
            :ref="'icon' + index"
            :data-clipboard-text="copyUrl"
            :style="{ animationDelay: 0.3 + 0.1 * index + 's' }"
          >
            <img class="icon-img" :src="item.icon" alt="" />
          </div>
          <div class="item-name">{{ item.name }}</div>
        </div>
      </div>
      <div class="list" v-show="shareType == 1">
        <div
          class="item"
          v-for="(item, index) in sharePicList"
          :key="index"
          @click="bindShareClick(index)"
        >
          <div
            class="item-icon"
            :data-clipboard-text="copyUrl"
            :style="{ animationDelay: 0.3 + 0.1 * index + 's' }"
          >
            <img class="icon-img" :src="item.icon" alt="" />
          </div>
          <div class="item-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  props: {
    shareType: {
      type: Number,
      default: 0
    },
    copyUrl: {
      type: String,
      default: ''
    },
    linkShareIcon: {
      type: Array,
      default: () => []
    },
    imageShareIcon: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      clipboard: null,
      list: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon5',
          name: '生成分享图'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接'
        }
      ],
      sharePicList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon1',
          name: '保存到手机'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        }
      ]
    }
  },
  watch: {
    linkShareIcon() {
      this.updateIcon()
    },
    imageShareIcon() {
      this.updateIcon()
    }
  },
  mounted() {
    this.updateIcon()
  },
  methods: {
    //更新图标
    updateIcon() {
      this.list = this.linkShareIcon.length ? this.linkShareIcon : this.list
      this.sharePicList = this.imageShareIcon.length
        ? this.imageShareIcon
        : this.sharePicList
      this.list.map((item, index) => {
        if (item.name == '复制链接') {
          let dom = this.$refs['icon' + index]
          dom = Array.isArray(dom) ? dom[0] : dom
          this.clipboard = new Clipboard(dom)
          this.clipboard.on('success', () => {
            this.$toast('复制链接成功,快去分享给你的好友吧')
          })
          this.clipboard.on('error', () => {
            this.$toast('复制失败，请手动复制')
          })
        }
      })
    },
    bindStop() {},
    //点击分享链接时的按钮
    bindClick(index) {
      this.$emit('link', index)
    },
    //点击分享图片时的按钮
    bindShareClick(index) {
      this.$emit('image', index)
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.share-content {
  position: absolute;
  left: 0;
  bottom: 0;
  position: relative;
  width: 100%;
  background: #f9f9f9;
  padding: 17px 20px;
  box-sizing: border-box;
  animation: moveup 0.3s ease;

  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    right: 5px;
    color: #000;
    font-size: 14px;
  }

  .list-scroll {
    //max-height: 190px;
    /*  overflow-y: scroll; */
  }

  .list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item {
      width: 25%;
      margin-bottom: 10px;

      .item-icon {
        margin: 0 auto;
        width: 60px;
        height: 60px;
        background: #ffffff;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        margin-bottom: 10px;
        animation: moveUpDown 0.3s ease-in-out 0.3s;

        .icon-img {
          transform: scale(0.33);
        }
      }

      .item-icon:active {
        transform: scale(0.95);
      }

      .item-name {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
      }
    }
  }
}

@keyframes moveup {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}

@keyframes moveUpDown {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  70% {
    opacity: 1;
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
